/**
 * leerlingAccount.js — herken een leerling-account op een Supabase-gebruiker.
 *
 * Leerlingen met e-mail-login (testscholen, demo) hebben in auth.users de
 * metadata role 'leerling'. Zo'n account hoort in het leerlingportaal, ook als
 * het per ongeluk via de docentenpagina /login is ingelogd (14-10-2026).
 */
export const LEERLING_START = '/student/leerstof';

export function isLeerlingAccount(user) {
  const rol = user?.user_metadata?.role || user?.user_metadata?.rol || user?.app_metadata?.role;
  return String(rol || '').toLowerCase() === 'leerling';
}
